
import Vue from 'vue';
import {mapState} from 'vuex';
import ScopeSelector from '../components/ScopeSelector.vue';

type Data = {
  files: string[];
  currentscope: string;
};

type Method = {
  setScope(): void;
};

type Computed = {
  scope: Array<string>;
  len: number;
};

export default Vue.extend<Data, Method, Computed>({
  name: 'temp',
  components: {
    ScopeSelector,
  },
  methods: {
    setScope() {
      this.$store.commit('SET_CURRENTSCOPE', this.currentscope);
    },
  },
  computed: {
    ...mapState(['scope']),
    len() {
      return this.scope.length;
    },
  },
  data: () => ({
    files: [],
    currentscope: '',
  }),
});
